import React, { useState } from 'react';

const UpdateMargin = () => {
  const [margin, setMargin] = useState('');
  const [message, setMessage] = useState('');

  const handleInputChange = (e) => {
    setMargin(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (margin !== '') {
      setMessage(`Margin has been updated to ${margin}%`);
    } else {
      setMessage('Please enter a valid margin value.');
    }
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '500px',
    margin: '0 auto',
    fontSize: '14px',
  };

  const inputStyle = {
    padding: '8px',
    fontSize: '14px',
    width: '100%',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '20px',
  };

  const buttonStyle = {
    padding: '8px 16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  };

  const messageStyle = {
    marginTop: '20px',
    color: 'green',
    fontSize: '14px',
    textAlign: 'center',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Set Margin</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>Enter Margin Percentage</label>
          <input
            type="number"
            value={margin}
            onChange={handleInputChange}
            placeholder="Enter Margin"
            style={inputStyle}
          />
        </div>

        <button type="submit" style={buttonStyle}>
          Update
        </button>
      </form>

      {message && <div style={messageStyle}>{message}</div>}
    </div>
  );
};

export default UpdateMargin;
